import type { Page, PageComponent } from '@/types'
import { ComponentRegistry } from './ComponentRegistry'

interface PageRendererProps {
  page: Page
}

export function PageRenderer({ page }: PageRendererProps) {
  return (
    <div className="page">
      {page.content.map((component, index) => (
        <ComponentRenderer key={component.id || `component-${index}`} component={component} />
      ))}
    </div>
  )
}

interface ComponentRendererProps {
  component: PageComponent
}

function ComponentRenderer({ component }: ComponentRendererProps) {
  const Component = ComponentRegistry[component.type]

  if (!Component) {
    if (import.meta.env.DEV) {
      return (
        <div className="bg-yellow-100 border border-yellow-400 p-4 my-2 rounded">
          <strong>Unknown component:</strong> {component.type}
        </div>
      )
    }
    return null
  }

  return (
    <Component {...component.props}>
      {component.children?.map((child) => (
        <ComponentRenderer key={child.id} component={child} />
      ))}
    </Component>
  )
}
